import Vue from 'vue';
import Router from 'vue-router';
import AllProducts from '../components/AllProducts';
import Product from '../components/Product';
// import CartCheckout from '../components/CartCheckout';
import About from '../components/About';
import NotFound from '../components/NotFound';
import store from '../store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'All products',
      component: AllProducts,
    },
    {
      path: '/products/:category',
      name: 'Products category',
      component: AllProducts,
    },
    {
      path: '/products/:category/discipline/:discipline',
      name: 'Products category and discipline',
      component: AllProducts,
    },
    {
      path: '/products/deals',
      name: 'Deals',
      component: AllProducts,
    },
    {
      path: '/product/:uid',
      name: 'Product',
      component: Product,
      beforeEnter: (to, from, next) => {
        // Navigation guard that checks the validity of the UID
        function isValid(uid) {
          const allTheProducts = Object.values(store.state.all_products)
            .reduce((prod, p) => prod.concat(p), []);
          const matchingProducts = allTheProducts.filter(p => p.uid === uid);
          return matchingProducts.length > 0;
        }

        if (!isValid(to.params.uid)) {
          next({ path: '/404', replace: true });
        } else {
          next();
        }
      },
    },
    // {
    //   path: '/checkout',
    //   name: 'Checkout',
    //   component: CartCheckout,
    // },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js